import { Action, createAction, createReducer, on, props } from '@ngrx/store';

export const setLoginMethod = createAction('[Login Method] Set loginMethod Info', props<{ loginMethod: string }>());

export function loginMethodReducer(pState: string | undefined, action: Action) {
  return createReducer(
    {},
    on(setLoginMethod, (state, loginMethod) => loginMethod.loginMethod)
  )(pState, action);
}
